import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import { Container } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setLoading } from 'redux/features/ui-slice';
import PATHS from 'lib/navigation/paths';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import { LocationsFilter } from 'views/rebranded-module/location-module/LocationsViewV2/components';
import {
  FILTER_TYPE,
  MAP_CENTER,
} from 'views/rebranded-module/location-module/LocationsViewV2/utils/constants';

const LocationsFilterOverlayV2 = dynamic(() => import(
  'views/rebranded-module/location-module/LocationsViewV2/components/LocationsFilterOverlayV2'
).then((file) => file.LocationsFilterOverlayV2));

const LocationsFilterWrapperV2 = (props) => {
  const {
    setMapCenter,
    filter,
    setFilter,
    searchQuery,
    handleSearchQueryChange,
    getLocationsData,
    content,
  } = props;

  const appNavigator = useAppNavigator();
  const dispatch = useDispatch();
  const [openFiltersOverlay, setOpenFiltersOverlay] = useState(false);

  const handleFiltersOverlayOpen = () => {
    setOpenFiltersOverlay(true);
  };
  const handleFiltersOverlayClose = () => {
    setOpenFiltersOverlay(false);
  };

  const updateMapCenter = (newFilter) => {
    switch (newFilter) {
      case FILTER_TYPE.INTERNATIONAL:
        setMapCenter(MAP_CENTER.INTERNATIONAL);
        break;
      case FILTER_TYPE.US:
        setMapCenter(MAP_CENTER.US);
        break;
      case FILTER_TYPE.CLUB:
        setMapCenter(MAP_CENTER.CLUB);
        break;
      default:
        setMapCenter(MAP_CENTER.ALL_LOCATIONS);
    }
  };

  const handleRadioFilterClick = (newFilter) => {
    if (filter == newFilter) return;
    if (newFilter === FILTER_TYPE.CLUB || filter === FILTER_TYPE.CLUB) {
      dispatch(setLoading(true));
      getLocationsData(newFilter === FILTER_TYPE.CLUB).then(() => {
        appNavigator.push(
          newFilter === FILTER_TYPE.CLUB
            ? PATHS.clubLocations()
            : PATHS.locations(),
          undefined,
          { scroll: false },
        );
      });
    }
    updateMapCenter(newFilter);
    setFilter(newFilter);
  };

  const handleOverlayFilterBtnClick = (newFilter) => {
    handleFiltersOverlayClose();
    handleRadioFilterClick(newFilter);
  };

  return (
    <Container maxWidth="xl">
      <LocationsFilter
        filter={filter}
        searchQuery={searchQuery}
        handleClick={handleRadioFilterClick}
        handleChange={handleSearchQueryChange}
        handleFiltersOverlayOpen={handleFiltersOverlayOpen}
        searchPlacholder={content.LocationsPage.searchLocationName}
        content={content}
      />
      {openFiltersOverlay && (
        <LocationsFilterOverlayV2
          open={openFiltersOverlay}
          filter={filter}
          handleFilter={handleOverlayFilterBtnClick}
          handleClose={handleFiltersOverlayClose}
          content={content}
        />
      )}
    </Container>
  );
};

export { LocationsFilterWrapperV2 };
